/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window.Vue = require("vue").default;

// Prefered: as a plugin (directive + filter) + custom placeholders support
import VueMask from "v-mask";
Vue.use(VueMask);

import moment from "moment";

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueToast, {
    position: 'bottom-left'
});


let language = document.documentElement.lang;

// Se pasa el tocken por defauld en el header
axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
    Language: language,
    currency: window.localStorage.getItem('currency'),
    "Access-Control-Allow-Origin": "*",
};

// Add a response interceptor
axios.interceptors.response.use(
    function(response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        return response;
    },
    function(error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error.response.status === 403 || error.response.status === 419) {
            // redirect to login page
            router.go();
        }
        return Promise.reject(error);
    }
);

// Importamos los componentes que seran globales
Vue.component("Loading", require("./components/LoadingComponent.vue").default);
Vue.component("Topnavbar", require("./components/TopNavbar.vue").default);
Vue.component("Footerside", require("./components/Footer.vue").default);
Vue.component("ModalGlobal", require("./components/ModalDialog.vue").default);
Vue.component("Shoppingcart", require("./components/ShoppingCartComponent.vue").default);
Vue.component("Autologout", require("./components/AutoLogout.vue").default);

import { ValidationObserver, ValidationProvider } from 'vee-validate';
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// Cargamos el archivo para las traducciones
import i18n from "./i18n";
// Importamos el archivo con las propiedades globales
import store from "./store.js";

// Obtenemos las Rutas definidas
import router from "./router";

let lang = store.state.Language;

router.beforeEach((to, from, next) => {
    if (lang === '' || lang === null) {
        const userLang = navigator.language || navigator.userLanguage;
        lang = userLang.split('-')[0];
        window.localStorage.setItem('langDefault', true);
        window.localStorage.setItem('lang', lang);
        store.dispatch('setLanguage', lang);
    
    }
    
    i18n.locale = store.state.Language;
    let hasAlbums = Object.values(store.state.albumes).length && to.name == "home";

    if (store.getters.authState) {
        store.dispatch("setModalLogin", false);
    }
    
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.state.userLoggedIn) {
            console.log("userLoggedIn", store.state.userLoggedIn);
            if (hasAlbums) {
                next({ name: "albumes" });
            }

            next();
        } else {
            next({ name: "home" });
        }
    }
    if (to.matched.some((record) => record.meta.disableIfLoggedIn)) {
        if (store.state.userLoggedIn && Object.values(store.state.albumes).length) {
            next({ name: "albumes" });
        } else {
            next();
        }
    } else {      
        next();
    }
    next();
});

Vue.filter("toCurrency", function(value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
    return formatter.format(value);
});

Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("YYYY-MM-DD");
    }
});

export const eventBus = new Vue();

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

if (document.getElementById("app")) {
    const app = new Vue({
        i18n,
        el: "#app",
        store,
        // components: { FooterComponent },
        router,
    });
}

// if (document.getElementById("vGalleryVideo")) {
//     const app = new Vue({
//         el: "#vGalleryVideo",
//     });
// }